import {createStyles, WithStyles} from '@material-ui/core';

export const styles = () =>
    createStyles({
        editorButtonWrapper: {
            display: 'inline-block'
        },
        editorButton: {
            background: '#fbfbfb',
            color: '#888',
            fontSize: '18px',
            border: 0,
            paddingTop: '5px',
            verticalAlign: 'bottom',
            height: '34px',
            width: '36px'
        }
    });

export type Classes = WithStyles<typeof styles>
